<template>
  <div class="cwSwitchWrapper" v-show="isVisible">
    <cw-toggle
      :label="cmpLabel"
      :value="currentValue"
      v-on:toggleChanged="valueChanged"
    ></cw-toggle>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cwToggle from './cwToggle.vue';
import expertviewMixin from './experviewMixin';

export default {
  name: 'CwSwitchWrapper',
  components: { cwToggle },
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {};
  },
  created() {
    this.$log.debug('cwSwitchWrapper::created()');
    this.selectedData = this.currentDataFromFwApp;
    this.applyRuleProvider(this.selectedData);
    this.valueChanged(this.selectedData);
  },
  computed: {
    ...mapGetters(['latestAppData', 'getRule']),

    currentValue() {
      // console.info(JSON.parse(this.currentDataFromFwApp));
      return JSON.parse(this.currentDataFromFwApp);
    },

    cmpLabel() {
      return this.getCactusString(this.cmpConfig.component.decorator.label_static);
    }
  },
  methods: {
    ...mapActions(['setRuleProvider']),

    valueChanged(newVal) {
      let fwApp = this.getFwApp();
      this.applyRuleProvider(newVal);

      this.$log.debug('cwDropdownWrapper::valueChanged', {
        app: fwApp.app,
        parameter: fwApp.param,
        value: newVal
      });

      this.setExpertViewParams({
        app: fwApp.app,
        parameter: fwApp.param,
        value: newVal
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cwSwitchWrapper {
  border: 1px solid #becdd7;
  border-radius: 8px;
  padding-left: 32px;
}
</style>
